<template>
  <PinInputRoot
    v-model="code"
    placeholder="○"
    class="flex gap-2"
    @complete="handleVerify"
  >
    <PinInputInput
      v-for="(id, index) in 6"
      :key="id"
      :index="index"
      class="w-1/6 h-14 text-sm rounded border text-center shadow-sm focus:ring focus:ring-actionfocus:outline-none"
    />
  </PinInputRoot>
</template>

<script setup lang="ts">
import { PinInputInput, PinInputRoot } from "radix-vue";

const model = defineModel<string>('modelValue', { required: true })

const code = computed({
  get() {
    return model.value?.split('') || []
  },
  set(value) {
    model.value = value.join('')
  }
})

const emit = defineEmits<{
  (e: 'complete', value: string): void
}>()

const handleVerify = (value: string[]) => {
  emit('complete', value.join(''))
}
</script>